import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { PipelineStatus, PipelineSummaryStats } from '../../const/PipelineTypes';
import summaryStyles from '../Pipeline/Summary.module.css';
import styles from './DashboardWorkflowSummary.module.css';

interface DashboardWorkflowSummaryProps {
  pipelineData: PipelineSummaryStats;
  className?: string;
}

interface StatusItem {
  label: string;
  value: number;
  status: PipelineStatus;
  iconClass: string;
}

const DASHBOARD_STATUSES: Array<{ status: PipelineStatus; label: string; iconClass: string }> = [
  { status: PipelineStatus.Success, label: 'Successful', iconClass: summaryStyles.statusIconGreen },
  { status: PipelineStatus.Failure, label: 'Failed', iconClass: summaryStyles.statusIconRed },
  { status: PipelineStatus.Warning, label: 'Warning', iconClass: summaryStyles.statusIconOrange },
  { status: PipelineStatus.Canceled, label: 'Canceled', iconClass: summaryStyles.statusIconGray }
];

const DashboardWorkflowSummary = ({ className, pipelineData }: DashboardWorkflowSummaryProps) => {
  const { isLoading, error, stats } = pipelineData;

  const statusItems: StatusItem[] = useMemo(() => {
    return DASHBOARD_STATUSES.map(({ status, label, iconClass }) => ({
      label,
      value: stats[status] ?? 0,
      status,
      iconClass
    }));
  }, [stats]);

  const header = (
    <div className={styles.header}>
      <div className={styles.title}>Overall SW Delivery Summary</div>
      <span className={styles.subtitle}>All Product Lines</span>
    </div>
  );

  if (isLoading) {
    return (
      <div>
        {header}
        <div id="waiting" className="waiting hidden">
          <div className="message"></div>
          <div className="loading"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`${styles.wrapper} ${className ?? ''}`}>
        {header}
        <div className={styles.loadingText}>Error while loading the success rate.</div>
      </div>
    );
  }

  return (
    <div className={`${styles.wrapper} ${className ?? ''}`}>
      {header}
      <div className={styles.row}>
        {statusItems.map((item) => (
          <div key={item.status} className={styles.kpi}>
            <div className={summaryStyles.kpiLabel}>
              Workflows
              <Link to={`/automation-flows/workflows?status=${item.status}`} className={styles.workflowsLink}>
                <i className="icon icon-arrow-right" aria-hidden />
              </Link>
            </div>
            <div className={summaryStyles.kpiValue}>{item.value}</div>
            <div className={summaryStyles.kpiStatus}>
              <span className={`${summaryStyles.statusIcon} ${item.iconClass}`}></span>
              <span>{item.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardWorkflowSummary;
